// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ws8HV","text":"style_text__dfs+X","actions":"style_actions__9+9gg","actions_btn":"style_actions_btn__1eMNg"};